export const STREAM_CHAT_TIMEOUT_MILLIS = 30000;
